import { styled } from '@mui/material/styles';
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  Fade,
  // Button,
} from '@mui/material';
import { useUserUrgesQuery } from '@/schema';
import { useNavigate } from 'react-router-dom';
import { SpecialBox } from '@/components/public/special-box';

const PREFIX = 'index';

const classes = {
  root: `${PREFIX}-root`,
  title: `${PREFIX}-title`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {},

  [`& .${classes.title}`]: {
    padding: theme.spacing(1, 2),
  },
}));

export default function Aider() {
  const navigate = useNavigate();

  const { data, loading, error } = useUserUrgesQuery();
  return (
    <Root>
      <div className={classes.root}>
        <Typography className={classes.title} variant="h6">
          贡献榜
        </Typography>
        <List>
          {data?.user_urges.length ? (
            data.user_urges.map((user, i) => {
              return (
                <Fade key={i} in timeout={i * 250}>
                  <ListItem
                    onClick={() => navigate(`/profile/${user?.username}`)}
                    sx={{
                      cursor: 'pointer',
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar src={user.avatar}></Avatar>
                    </ListItemAvatar>
                    <ListItemText>
                      <Typography noWrap>{user.nickname}</Typography>
                      <Typography noWrap variant="caption">
                        {user.description}
                      </Typography>
                    </ListItemText>
                    {/* <ListItemSecondaryAction>
                      <Button>
                        <Typography>关注</Typography>
                      </Button>
                    </ListItemSecondaryAction> */}
                  </ListItem>
                </Fade>
              );
            })
          ) : (
            <SpecialBox
              loading={loading}
              loadingTitle="加载中"
              error={!!error}
              placeholder
              placeholderTitle="加载中"
            />
          )}
        </List>
      </div>
    </Root>
  );
}
